import guard from "@/guard/routeGuard.js";
import store from "@/store/index";
import Vue from "vue";
import VueRouter from "vue-router";
const { validationRoute } = guard;

Vue.use(VueRouter);

const routes = [

  
  {
    path: "/quantidade-insumo-parametrizados",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Quantidade de Insumos", 
        permission: "view_requests",
        component: () => import("@/components/modules/parameters/GridParameters.vue"),
      },
    ],
  },

  {
    path: "/gel-almoxarifado",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Solicitação de Gel Lubrificante", 
        permission: "view_requests",
        component: () => import("@/components/modules/gel/warehouse/GelOrderWarehouse.vue"),
      },
    ],
  },

  {
    path: "/consultar-gel",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Solicitação de Gel Lubrificante", 
        permission: "view_requests",
        component: () => import("@/components/modules/gel/solicitations/GelSolicitations.vue"),
      },
    ],
  },

  {
    path: "/autorizar-gel",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorizar Solicitações de Gel Lubrificante", 
        permission: "view_requests",
        component: () => import("@/components/modules/gel/consolidation/GelAuthorization.vue"),
      },
    ],
  },

  {
    path: "/solicitar-gel",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Incluir Solicitação de Gel Lubrificante", 
        permission: "add_requests",
        component: () => import("@/components/modules/gel/solicitations/GelSolicitationsCreate.vue"),
      },
    ],
  },

  {
    path: "/gel-consolidados",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorização de Solicitações de Gel Lubrificante", 
        permission: "view_consolidations",
        component: () => import("@/components/modules/gel/consolidation/GelConsolidations.vue"),
      },
    ],
  },

  // LOGIN
  {
    path: "/",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/components/modules/login/Login.vue"),
      },
    ],
  },

  // DASHBOARD
  {
    path: "/dashboard",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Dashboard",
        permission: "dashboard",
        component: () => import("@/components/modules/dashboard/Dashboard.vue"),
      },
    ],
  },

  // CAD. BÁSICOS
  // PERFIS
  {
    path: "/perfis",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Perfis do Usuário",
        permission: "view_profiles",
        component: () => import("@/components/modules/profiles/Grid.vue"),
      },
    ],
  },

  // USUARIOS
  {
    path: "/usuarios",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Usuários",
        permission: "view_users",
        component: () => import("@/components/modules/users/Grid.vue"),
      },
    ],
  },
  // INSTITUIÇÃO
  {
    path: "/instituicao",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Instituições",
        permission: "view_instituitions",
        component: () => import("@/components/modules/institution/Grid.vue"),
      },
    ],
  },

  // ROTA DE FORMULA - no component coloco nome da pasta e nome do arquivo criado //
  {
    path: "/formulas",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Solicitações de Fórmulas",
        permission: "view_requests",
        component: () => import("@/components/modules/formulas/solicitation/FormulaSolicitations.vue"),
      },
    ],
  },

  //ROTA DE PEDIDO DE FORMULA //
  {
    path: "/solicitar_formulas",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Solicitação de Fórmulas",
        permission: "add_requests",
        component: () => import("@/components/modules/formulas/solicitation/FormulaSolicitationCreateEdit2.vue"),
      },
    ],
  },


  {
    path: "/formulas-almoxarifado",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Solicitações de Fórmulas",
        permission: "distribute",
        component: () => import("@/components/modules/formulas/solicitation/FormulaSolicitationsWarehouse.vue"),
      },
    ],
  },

  {
    path: "/formulas-consolidadas",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorizar Solicitações de Fórmulas",
        permission: "view_consolidations",
        component: () => import("@/components/modules/formulas/consolidation/FormulaConsolidations.vue"),
      },
    ],
  },

  // REABERTURA DE PRAZO
  {
    path: "/reabertura-prazo",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Reabertura de Prazo",
        permission: "view_deadline",
        component: () => import("@/components/modules/reopenDeadline/Grid.vue"),
      },
    ],
  },
  
  //DETALHAR
  {
    path: "/autorizar-formulas",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorização de Solicitações de Fórmulas",
        permission: "dispensing_requests",
        component: () => import("@/components/modules/formulas/consolidation/FormulaAuthorization.vue"),
      },
    ],
  },

  //PEDIDOS - ALMOXARIFADO
  {
    path: "/insumos",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Registros de Entrada de Insumos",
        permission: "view_inputs",
        component: () => import("@/components/modules/suppliesOrder/SuppliesOrderGrid.vue"),
      },
    ],
  },

  //CONSULTAR - PRESERVATIVOS
  {
    path: "/preservativos",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Consultar Solicitação de Preservativos ",
        permission: "view_requests",
        component: () => import("@/components/modules/condom/solicitation/CondomSolicitations.vue"),
      },
    ],
  },

 // SOLICITAR PRESERVATIVO
  {
    path: "/solicitar-preservativo",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Incluir Solicitação de Preservativos ",
        permission: "add_requests",
        component: () => import("@/components/modules/condom/solicitation/CondomSolicitationCreate.vue"),
      },
    ],
  },


  // PEDIDO PRESERVATIVO
  {
    path: "/preservativos-almoxarifado",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Solicitações de Preservativos",
        permission: "distribute",
        component: () => import("@/components/modules/condom/solicitation/CondomSolicitationsWarehouse.vue"),
      },
    ],
  },

  // CONSOLIDAR PRESERVATIVO
  {
    path: "/autorizar-preservativos",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorizar Solicitações de Preservativos",
        permission: "consolidate_requests",
        component: () => import("@/components/modules/condom/authorization/CondomAuthorization.vue"),
      },
    ],
  },

  // ROTA DE DETALHAR PRESERVATIVOS CONSOLIDAÇÃO
  {
    path: "/preservativos-consolidados",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Autorizar Solicitações de Preservativos ",
        permission: "view_consolidations",
        component: () => import("@/components/modules/condom/authorization/CondomConsolidations.vue"),
      },
    ],
  },

  // MINHA CONTA
  {
    path: "/minha-conta",
    beforeEnter: validationRoute,
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Minha Conta",
        permission: "account",
        component: () => import("@/components/modules/my-account/Account.vue"),
      },
    ],
  },

  // RESETAR SENHA
  {
    path: "/esqueci-minha-senha",
    component: () => import("@/views/ViewWithoutLayout.vue"),
    children: [
      {
        path: "",
        name: "Esqueci minha senha",
        component: () => import("@/components/modules/password/Password.vue"),
      },
    ],
  },

  {
    path: "/relatorio-controle-estoque",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Relatório de Controle de Estoque",
        permission: "reports",
        component: () => import("@/components/modules/reports/StockControlReport.vue")
      },
    ],
  },

  {
    path: "/relatorio-movimento-estoque",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Relatório de Movimentação de Estoque",
        permission: "reports",
        component: () => import("@/components/modules/reports/StockMovementReport.vue")
      },
    ],
  },

  {
    path: "/relatorio-entrada-saida",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Relatório de Controle de Entrada e Saldo de Insumos",
        permission: "reports",
        component: () => import("@/components/modules/reports/InputControlReport.vue")
      },
    ],
  },

  {
    path: "/relatorio-acompanhamento",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Relatorio de Acompanhamento de Insumos",
        permission: "reports",
        component: () => import("@/components/modules/reports/SuppliesMonitoringReport.vue")
      },
    ],
  },

  {
    path: "/relatorio-controle-autorizados-entregues",
    component: () => import("@/views/ViewWithLayout.vue"),
    children: [
      {
        path: "",
        name: "Relatorio de Acompanhamento de Insumos Autorizados x Entregues",
        permission: "reports",
        component: () => import("@/components/modules/reports/DeliveredSuppliesReport.vue")
      },
    ],
  },
];

store.state.localRoutes = routes;

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: 'history'
});

export default router;
